import { createContext, useContext } from 'react';
import { useProductTypesAndCustomerGroups } from '../hooks/useProductTypesAndCustomerGroups';

const CustomerGroupAndProductTypesContext = createContext([false, [], []]);

export function CustomerGroupAndProductTypesProvider({
	selectedCustomer,
	children,
}) {
	const [isLoading, productTypes, customerGroups] =
		useProductTypesAndCustomerGroups(selectedCustomer);

	return (
		<CustomerGroupAndProductTypesContext.Provider
			value={[isLoading, productTypes, customerGroups]}
		>
			{children}
		</CustomerGroupAndProductTypesContext.Provider>
	);
}

export const useCustomerGroupAndProductTypes = () =>
	useContext(CustomerGroupAndProductTypesContext);
